<template>
    <div id="indicators-carousel-case-studies" class="relative w-full">
        <div ref="carousel-case-studies" id="carouselCaseStudies"
            class="relative sm:h-780 overflow-hidden borderRadius max-sm:h-[820px] border border-gray-100 lg:h-600">
            <div id="carousel-item-caseStudies1"
                class="bg-white duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                data-carousel-item="active">
                <div class="flex relative h-full items-center w-full lg:py-12 lg:pl-12 flex-col-reverse lg:flex-row">
                    <slot name="case1"></slot>
                    <div
                        class="w-full lg:pt-16 lg:pl-8  lg:absolute h-auto sm:h-full right-0 2xl:top-[10%] top-[15%] sm:pt-0 my-0 mx-auto lg:w-3/5 flex items-center justify-center max-w-600 lg:max-w-780">
                        <img alt="" class=" absolute -left-[60px] -top-[50px] sm:-top-[120px] sm:-left-[110px] lazyload"
                            data-src="../../../images/polygon-1-case.webp" />
                        <img alt="" class="hidden lg:block absolute xl:-bottom-[1rem] bottom-10 -right-[90px] lazyload"
                            data-src="../../../images/polygon-2-case.webp" />
                        <img :alt="loading['audentes'] ? '' : 'audentes case'"
                            class="aspect-auto my-0 mx-auto z-20 lazyload lg:absolute lg:bottom-[150px]"
                            :data-src="audentesImageSrc" @load="handleImageLoad('audentes')" />
                        <img v-if="loading['audentes']" class="z-10 w-[100px] h-[100px] mb-[250px]" alt=""
                            src="../../../images/loader.png" />
                    </div>
                </div>
            </div>
            <div id="carousel-item-caseStudies2"
                class="bg-white duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                data-carousel-item>
                <div class="flex relative items-center w-full  lg:py-12 lg:pl-12 flex-col-reverse lg:flex-row">
                    <slot name="case2"></slot>
                    <div
                        class="w-full lg:pt-16 lg:pl-8  lg:absolute h-full right-0 2xl:top-[10%] top-[15%] sm:pt-0 my-0 mx-auto lg:w-3/5 flex items-center justify-center max-w-600 lg:max-w-780">
                        <img alt="" class="lazyload absolute -left-[60px] -top-[50px] sm:-top-[120px] sm:-left-[110px]"
                            data-src="../../../images/polygon-1-case.webp" />
                        <img alt="" class="lazyload hidden lg:block absolute xl:-bottom-[1rem]  bottom-10 -right-[90px]"
                            data-src="../../../images/polygon-2-case.webp" />
                        <img :alt="loading['looxis'] ? '' : 'looxis case'"
                            class="aspect-auto my-0 mx-auto z-20 lazyload lg:absolute lg:bottom-[150px]"
                            :data-src="looxisImageSrc" @load="handleImageLoad('looxis')" />
                        <img v-if="loading['looxis']" class="z-10 w-[100px] h-[100px] mb-[250px]" alt=""
                            src="../../../images/loader.png" />
                    </div>
                </div>
            </div>
            <div id="carousel-item-caseStudies3"
                class="bg-white duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                data-carousel-item>
                <div class="flex relative items-center w-full  lg:py-12 lg:pl-12 flex-col-reverse lg:flex-row">
                    <slot name="case3"></slot>
                    <div
                        class="w-full lg:pt-16 lg:pl-8  lg:absolute h-full right-0 2xl:top-[10%] top-[15%] sm:pt-0 my-0 mx-auto lg:w-3/5 flex items-center justify-center max-w-600 lg:max-w-780">
                        <img alt="" class="lazyload absolute -left-[60px] -top-[50px] sm:-top-[120px] sm:-left-[110px]"
                            data-src="../../../images/polygon-1-case.webp" />
                        <img alt="" class="lazyload hidden lg:block absolute xl:-bottom-[1rem] bottom-10 -right-[90px]"
                            data-src="../../../images/polygon-2-case.webp" />
                        <img :data-src="ocamImageSrc" @load="handleImageLoad('ocam')"
                            :alt="loading['ocam'] ? '' : 'ocam case'"
                            class="aspect-auto my-0 mx-auto lazyload z-20 lg:absolute lg:bottom-[150px]"
                            data-src="../../../images/ocam-case/ocam-case.webp" />
                        <img v-if="loading['ocam']" class="z-10 w-[100px] h-[100px] mb-[250px]" alt=""
                            src="../../../images/loader.png" />
                    </div>
                </div>
            </div>
            <div id="carousel-item-caseStudies4"
                class="bg-white duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                data-carousel-item>
                <div class="flex relative items-center w-full  lg:py-12 lg:pl-12 flex-col-reverse lg:flex-row">
                    <slot name="case4"></slot>
                    <div
                        class="w-full lg:pt-16 lg:pl-8  lg:absolute h-full right-0 2xl:top-[10%] top-[15%] sm:pt-0 my-0 mx-auto lg:w-3/5 flex items-center justify-center max-w-600 lg:max-w-780">
                        <img alt="" class="lazyload absolute -left-[60px] -top-[50px] sm:-top-[120px] sm:-left-[110px]"
                            data-src="../../../images/polygon-1-case.webp" />
                        <img alt="" class="lazyload hidden lg:block absolute xl:-bottom-8 bottom-10 -right-[90px]"
                            data-src="../../../images/polygon-2-case.webp" />
                        <img :alt="loading['musicSchool'] ? '' : 'music school case'"
                            class="aspect-auto my-0 mx-auto z-20 lazyload lg:absolute lg:bottom-[140px]"
                            :data-src="musicSchoolImageSrc" @load="handleImageLoad('musicSchool')" />
                        <img v-if="loading['musicSchool']" class="z-10 w-[100px] h-[100px] mb-[250px]" alt=""
                            src="../../../images/loader.png" />
                    </div>
                </div>
            </div>
            <div id="carousel-item-caseStudies5"
                class="bg-white duration-700 flex justify-center items-center rounded-3xl ease-in-out"
                data-carousel-item>
                <div class="flex relative items-center w-full  lg:py-12 lg:pl-12 flex-col-reverse lg:flex-row">
                    <slot name="case5"></slot>
                    <div
                        class="w-full lg:pt-16 lg:pl-8  lg:absolute h-full right-0 2xl:top-[10%] top-[15%] sm:pt-0 my-0 mx-auto lg:w-3/5 flex items-center justify-center max-w-600 lg:max-w-780">
                        <img alt="" class="lazyload absolute -left-[60px] -top-[50px] sm:-top-[120px] sm:-left-[110px]"
                            data-src="../../../images/polygon-1-case.webp" />
                        <img alt="" class="lazyload hidden lg:block absolute xl:-bottom-8 bottom-10 -right-[90px]"
                            data-src="../../../images/polygon-2-case.webp" />
                        <img :alt="loading['megamarket'] ? '' : 'megamarket case'"
                            class="aspect-auto my-0 mx-auto z-20 lg:absolute lazyload lg:bottom-[140px]"
                            :data-src="megamarketImageSrc" @load="handleImageLoad('megamarket')" />
                        <img v-if="loading['megamarket']" class="z-10 w-[100px] h-[100px] mb-[250px]" alt=""
                            src="../../../images/loader.png" />
                    </div>
                </div>
            </div>
        </div>
        <div
            class="flex items-end justify-center min-[450px]:justify-between lg:justify-center min-[450px]:mx-0 sm:mx-0 mx-4">
            <a :href="getPath()"
                class="btn-primary hidden lg:hidden  max-sm:mb-0 min-[450px]:flex justify-center items-center full-case-big transition duration-200">
                SEE FULL CASE STUDY
            </a>
            <div
                class="flex carousel-arrows space-x-12 min-[450px]:space-x-1  items-center mt-8 sm:space-x-12 justify-center">
                <button aria-label="previous arrow" id="caseStudiesCarouselPrev"
                    class="border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer group focus:outline-none transition duration-200"
                    data-carousel-prev>
                    <svg aria-hidden="true"
                        class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6" fill="none"
                        stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"></path>
                    </svg>
                </button>
                <div class="flex space-x-3 justify-center">
                    <button id="carousel-indicator-caseStudies1" class="slider max-sm:pointer-events-none"
                        aria-current="true" aria-label="Slide 1" data-carousel-slide-to="0"></button>
                    <button id="carousel-indicator-caseStudies2" class="slider max-sm:pointer-events-none"
                        aria-current="false" aria-label="Slide 2" data-carousel-slide-to="1"></button>
                    <button id="carousel-indicator-caseStudies3" class="slider max-sm:pointer-events-none"
                        aria-current="false" aria-label="Slide 3" data-carousel-slide-to="2"></button>
                    <button id="carousel-indicator-caseStudies4" class="slider max-sm:pointer-events-none"
                        aria-current="false" aria-label="Slide 4" data-carousel-slide-to="3"></button>
                    <button id="carousel-indicator-caseStudies5" class="slider max-sm:pointer-events-none"
                        aria-current="false" aria-label="Slide 5" data-carousel-slide-to="4"></button>
                </div>
                <button aria-label="next arrow" id="caseStudiesCarouselNext"
                    class=" border border-grayBorder hover:border-mainColor rounded-full flex items-center justify-center w-14 h-14 cursor-pointer transition duration-200 group focus:outline-none"
                    data-carousel-next>
                    <svg aria-hidden="true"
                        class="w-5 h-5 group-hover:text-mainColor transition duration-200 sm:w-6 sm:h-6" fill="none"
                        stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import { Carousel } from "flowbite";
export default {
    name: "CaseStudies",

    data() {
        return {
            touchStartXCaseStudies: 0,
            touchEndXCaseStudies: 0,
            currentCarouselPosition: 0,
            loading: {
                looxis: true,
                audentes: true,
                ocam: true,
                musicSchool: true,
                megamarket: true
            },
            looxisImageSrc: "../../../images/looxis-case/looxis-case.webp",
            audentesImageSrc: "../../../images/audentes-case/audentes-case.webp",
            ocamImageSrc: "../../../images/ocam-case/ocam-case.webp",
            musicSchoolImageSrc: "../../../images/music-school-case/music-school-case.webp",
            megamarketImageSrc: "../../../images/megamarket-case/megamarket-case.webp",
        };
    },
    methods: {
        handleImageLoad(imageKey) {
            this.loading[imageKey] = false;
        },
        getPath() {
            switch (this.currentCarouselPosition) {
                case 0:
                    return "/portfolio/audentes";
                case 1:
                    return "/portfolio/looxis";
                case 2:
                    return "/portfolio/ocam";
                case 3:
                    return "/portfolio/music-school";
                case 4:
                    return "/portfolio/megamarket";
                default:
                    return "/portfolio";
            }
        },
    },
    mounted() {
        const itemsCaseStudies = [
            {
                position: 0,
                el: document.getElementById("carousel-item-caseStudies1"),
            },
            {
                position: 1,
                el: document.getElementById("carousel-item-caseStudies2"),
            },
            {
                position: 2,
                el: document.getElementById("carousel-item-caseStudies3"),
            },
            {
                position: 3,
                el: document.getElementById("carousel-item-caseStudies4"),
            },
            {
                position: 4,
                el: document.getElementById("carousel-item-caseStudies5"),
            },
        ];

        const optionsCaseStudies = {
            defaultPosition: 0,
            interval: 5000,
            indicators: {
                items: [
                    {
                        position: 0,
                        el: document.getElementById("carousel-indicator-caseStudies1"),
                    },
                    {
                        position: 1,
                        el: document.getElementById("carousel-indicator-caseStudies2"),
                    },
                    {
                        position: 2,
                        el: document.getElementById("carousel-indicator-caseStudies3"),
                    },
                    {
                        position: 3,
                        el: document.getElementById("carousel-indicator-caseStudies4"),
                    },
                    {
                        position: 4,
                        el: document.getElementById("carousel-indicator-caseStudies5"),
                    },
                ],
            },
            onChange: (selectedIndex) => {
                this.currentCarouselPosition = selectedIndex._activeItem.position
            },
        };
        const carouselCaseStudies = new Carousel(itemsCaseStudies, optionsCaseStudies);

        carouselCaseStudies.cycle();

        const carouselCaseStudiesElement = document.getElementById("carouselCaseStudies");
        const caseStudiesCarouselPrev = document.getElementById("caseStudiesCarouselPrev");
        const caseStudiesCarouselNext = document.getElementById("caseStudiesCarouselNext");

        caseStudiesCarouselPrev.addEventListener("click", () => {
            carouselCaseStudies.prev();
        }, { passive: true });
        caseStudiesCarouselNext.addEventListener("click", () => {
            carouselCaseStudies.next();
        }, { passive: true });


        if (window.location.pathname === "/") {
            const caseStudiesContainer = document.getElementById(
                "case-studies-container"
            );

            window.addEventListener("scroll", function () {
                const scrollPosition = window.scrollY;

                const triggerPosition =
                    caseStudiesContainer.offsetTop - window.innerHeight + 100;

                if (scrollPosition > triggerPosition) {
                    caseStudiesContainer.style.opacity = 1;
                    caseStudiesContainer.style.transform = "translateY(0)";
                }
            }, { passive: true });
        }

        const handleTouchStartCaseStudies = (event) => {
            this.touchStartXCaseStudies = event.touches[0].clientX;
        }

        const handleTouchEndCaseStudies = (event) => {
            this.touchEndXCaseStudies = event.changedTouches[0].clientX;
            handleSwipeCaseStudies();
        }

        const handleSwipeCaseStudies = () => {
            const swipeThreshold = 50;
            const swipeDistance = this.touchEndXCaseStudies - this.touchStartXCaseStudies;

            if (swipeDistance > swipeThreshold) {
                carouselCaseStudies.prev();
            } else if (swipeDistance < -swipeThreshold) {
                carouselCaseStudies.next();
            }
        }
        carouselCaseStudiesElement.addEventListener(
            "touchstart",
            handleTouchStartCaseStudies, { passive: true }
        );
        carouselCaseStudiesElement.addEventListener(
            "touchend",
            handleTouchEndCaseStudies, { passive: true }
        );

    },

};
</script>
